export const environment = {
  production: false,
  API_URL: 'https://api-dev.medyal.net/v1/',
  // API_URL: 'http://localhost:5000/v1/',
  TWITTER_API_BASE_URL: 'https://api.twitter.com/'
};
